import ApiService from "./api.service";

// const prepareFormSearch = function (form) {
//   let query = {}
//   query.issue_date_from = form.issue_date.start;
//   query.issue_date_to = form.issue_date.end;
//   if (form.type) query.type = form.type;
//   return query
// }

export const Products = {
  get() {
    return ApiService.get("/products");
  },
  save(data) {
    const {
      id,
      bodyFormData
    } = data;
    return ApiService.customRequest({
      method: 'post',
      url: `/products${id? `/${id}`: ''}`,
      data: bodyFormData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  remove(id) {
    return ApiService.delete(`/products/${id}`);
  },
  getCategories() {
    return ApiService.get("/products/categories");
  },
  addCategory(data) {
    return ApiService.post("/products/categories", data);
  },
  removeCategory(id) {
    return ApiService.delete(`/products/categories/${id}`);
  },
  editCategory(id, body) {
    return ApiService.put(`/products/categories/${id}`, body);
  },
};

export default {
  Products
};